'use strict';

import React from 'react';
import { browserHistory } from 'react-router'

require('styles/Header.scss');

class HeaderComponent extends React.Component {
  render() {
    return (
      <div className="header-component row header">
        <a className="float-left text-white ml-20" onClick={browserHistory.goBack}>返回</a>
        <span className="title">{this.props.title}</span>
        <a className="float-right text-white ml-20 visibility-hidden" onClick={browserHistory.goBack}>返回</a>
      </div>
    );
  }
}

HeaderComponent.displayName = 'HeaderComponent';

// Uncomment properties you need
// BackComponent.propTypes = {};
// BackComponent.defaultProps = {};

export default HeaderComponent;



// WEBPACK FOOTER //
// ./src/components/HeaderComponent.js